export const STORY_STATUSES: Record<string, StoryStatus> = {
  UNSCHEDULED: 'Unscheduled',
  UNSTARTED: 'Unstarted',
  STARTED: 'Started',
  FINISHED: 'Finished',
  DELIVERED: 'Delivered',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
}

export const BUG_STATUSES: Record<string, StoryStatus> = {
  UNSTARTED: 'Unstarted',
  STARTED: 'Started',
  FINISHED: 'Finished',
  DELIVERED: 'Delivered',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
}

export const CHORE_STATUSES: Record<string, StoryStatus> = {
  UNSTARTED: 'Unstarted',
  STARTED: 'Started',
  ACCEPTED: 'Accepted',
}

export const RELEASE_STATUSES: Record<string, StoryStatus> = {
  UNSTARTED: 'Unstarted',
  ACCEPTED: 'Accepted',
}
